import script from "./SongRegConfirmAndSave.vue?vue&type=script&setup=true&lang=ts"
export * from "./SongRegConfirmAndSave.vue?vue&type=script&setup=true&lang=ts"

import "./SongRegConfirmAndSave.vue?vue&type=style&index=0&id=217c4fc6&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-217c4fc6"]])

export default __exports__